import { Box, Button, Card, CardContent, Tooltip, Typography } from '@mui/material'
import RestartAltRoundedIcon from '@mui/icons-material/RestartAltRounded'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import DateRangeFilter from '../../../components/DateRangeFilter'
import InlineInfoNote from '../../../components/InlineInfoNote'
import UserReportDownloadComponent from './UserReportDownloadComponent'

const SharedUserReportHeader = ({
  dateRangeValue,
  onDateRangeChange,
  onResetDateRange,
  showReset = false,
  downloadProps = {},
  downloadContent = null,
  noteMessage = 'Solo puedes escoger un rango de fechas máximo de 12 meses.',
  compactPeriodNote = false
}) => (
  <Card
    elevation={0}
    sx={{
      mt: 3,
      borderRadius: '16px',
      border: '1px solid #d6e1ed',
      boxShadow: '0 3px 9px #27588d04',
      '& .report-period-trigger, & .report-period-value, & .report-period-label, & .report-period-divider': {
        fontSize: '13px !important'
      }
    }}
  >
    <CardContent
      sx={{
        px: { xs: 1.5, sm: '20px' },
        py: { xs: 1.5, sm: '16px' },
        '&:last-child': { pb: { xs: 1.5, sm: '16px' } }
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 1.5
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: { xs: 'stretch', md: 'flex-start' },
            justifyContent: 'space-between',
            gap: 2,
            flexWrap: { xs: 'wrap', md: 'nowrap' }
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: { xs: 'stretch', sm: 'center' },
              flexWrap: 'wrap',
              gap: 1,
              minWidth: 0,
              flex: '1 1 360px',
              '& .react-filter-box': {
                marginTop: 0
              }
            }}
          >
            <Typography
              sx={{
                fontSize: 15,
                color: '#334155',
                fontWeight: 700,
                whiteSpace: 'nowrap'
              }}
            >
              Periodo de búsqueda
            </Typography>

            <DateRangeFilter
              value={dateRangeValue}
              onChange={onDateRangeChange}
              inputTitle="Periodo de búsqueda"
              variant="modern"
            />

            {compactPeriodNote && (
              <Tooltip slotProps={{ tooltip: { sx: { fontSize: '10px' } } }} title={noteMessage} arrow placement="top">
                <Box
                  component="span"
                  tabIndex={0}
                  aria-label={noteMessage}
                  sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 0.5,
                    minHeight: 24,
                    px: 1.25,
                    borderRadius: 999,
                    bgcolor: '#f5f5f5',
                    color: 'rgba(0, 0, 0, 0.6)',
                    fontSize: 10,
                    fontWeight: 500,
                    lineHeight: 1,
                    whiteSpace: 'nowrap',
                    cursor: 'help',
                    '&:focus-visible': {
                      outline: '2px solid #7899bd',
                      outlineOffset: '2px'
                    }
                  }}
                >
                  <InfoOutlinedIcon sx={{ width: 14, height: 14, flexShrink: 0, m: 0 }} />
                  <Box component="span" sx={{ fontSize: '12px' }}>
                    Máx. 12 meses
                  </Box>
                </Box>
              </Tooltip>
            )}

            {showReset && (
              <Button
                variant="text"
                size="small"
                onClick={onResetDateRange}
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 0.5,
                  color: '#597FA9',
                  cursor: 'pointer',
                  minWidth: 'auto',
                  minHeight: 24,
                  px: 1.25,
                  py: 0,
                  fontSize: 10,
                  fontWeight: 500,
                  lineHeight: 1,
                  whiteSpace: 'nowrap',
                  textTransform: 'none',
                  borderRadius: 999,
                  '& .MuiSvgIcon-root': {
                    width: 14,
                    height: 14
                  },
                  '&:hover': { backgroundColor: '#f1f5f9' }
                }}
              >
                <RestartAltRoundedIcon aria-hidden="true" />
                <span>Restablecer</span>
              </Button>
            )}
          </Box>

          <Box
            className="user-report-download-action"
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: { xs: 'flex-start', md: 'flex-end' },
              flexWrap: 'wrap',
              ml: { xs: 0, md: 'auto' },
              flexShrink: 0,
              '& .download-doble-reports, & .download-doble-reports-arrow': {
                height: '38px !important'
              }
            }}
          >
            {downloadContent || <UserReportDownloadComponent {...downloadProps} />}
          </Box>
        </Box>

        {!compactPeriodNote && (
          <InlineInfoNote
            title="Nota:"
            message={noteMessage}
            singleLine
            sx={{
              width: '100%'
            }}
          />
        )}
      </Box>
    </CardContent>
  </Card>
)

export default SharedUserReportHeader
